<script>
    import { allProjectFields, allTemplateFields } from "../../Participaid.svelte";

    import LoadingSpinner from "../LoadingSpinner.svelte";
    import Reporter from "../../lib/error.js";

    import Select, {Option} from '@smui/select';
    import Icon from '@smui/select/icon/index';
    import HelperText from '@smui/select/helper-text/index';
    import Button, {Group, GroupItem, Label} from '@smui/button';

    export let selectedFieldId = "";
    export let selectedField;
    export let label = "Choose administration period";
    export let help = "";

    let options = [
        "DAILY",
        "BI_WEEKLY",
        "TRI_WEEKLY",
        "WEEKLY",
        "MONTHLY",
        "QUARTERLY",
        "HALF_QUARTERLY",
        "YEARLY"
    ];

</script>

<!-- TODO: for some reason it returns the text value instead of the option avlue -->
<Select enhanced variant="outlined" withLeadingIcon bind:value={selectedFieldId} {label} style="width: 100%">
    <span slot="icon"><Icon class="material-icons">work</Icon></span>
    {#each options as option}
        <Option
                value={option}
                selected={selectedFieldId == option}>
        {option.toLowerCase().replace("_", " ")}
        </Option>
    {/each}
</Select>

{#if help}
    <HelperText id="helper-text-persistent-c" persistent>{help}</HelperText>
{/if}

<style>
    option {
        text-transform: capitalize;
    }
</style>